import { action } from 'typesafe-actions';

import { IInspectorParams } from 'APIPackage/KnmModule/interfaces/IInspectorParams';
import { IChangePasswordParams } from 'APIPackage/AccountModule/interfaces/IChangePasswordParams';

import { PersonalAccountActionsEnum } from '../enums/PersonalAccountActionsEnum';

export const personalAccountGetKnmInspectors = () =>
  action(PersonalAccountActionsEnum.PERSONAL_ACCOUNT_GET_KNM_INSPECTORS);
export const personalAccountUpdateKnmInspectors = (data: IInspectorParams[], organizationId?: string) =>
  action(PersonalAccountActionsEnum.PERSONAL_ACCOUNT_UPDATE_KNM_INSPECTORS, { data, organizationId });
export const personalAccountUpdatePassword = (params: IChangePasswordParams) =>
  action(PersonalAccountActionsEnum.PERSONAL_ACCOUNT_UPDATE_PASSWORD, { params });
